import { render } from "./ProgressBarCALL.vue?vue&type=template&id=bc7a4674"
import script from "./ProgressBarCALL.vue?vue&type=script&lang=js"
export * from "./ProgressBarCALL.vue?vue&type=script&lang=js"

import "./ProgressBarCALL.vue?vue&type=style&index=0&id=bc7a4674&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__